import { render, staticRenderFns } from "./Detail-Opportunity.vue?vue&type=template&id=34bafa61&scoped=true"
import script from "./Detail-Opportunity.vue?vue&type=script&lang=js"
export * from "./Detail-Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Detail-Opportunity.vue?vue&type=style&index=0&id=34bafa61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bafa61",
  null
  
)

export default component.exports